module.exports = __webpack_public_path__ + "static/media/main1.eeece036.png";